import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import i18n from './i18n';
import VueMeta from 'vue-meta'
import VueClipboard from 'vue-clipboard2'
import './plugins/sweetalertLazy';
import './plugins/notify';

Vue.config.productionTip = false

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true,
});
Vue.use(VueClipboard)

new Vue({
    vuetify,
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')

// Web Vitals en chunk aparte para no engordar el bundle inicial
import(/* webpackChunkName: "web-vitals" */ './utils/webVitals')
    .then(({ initWebVitals }) => initWebVitals())
    .catch(() => {})